import type { IBrandConfig } from './types';

const PARTYHAT_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://www.getpartyhat.com/privacy',
  },
  termsOfService: {
    kind: 'external',
    url: 'https://www.getpartyhat.com/terms',
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  vaultProject: 'partyhat',
  adaChat: true,
  accountDetails: false,
  personalInformation: false,
  secureUpload: false,
  billingDetails: false,
  offersAndUpgrades: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  defaultBillingCategoryKey: 'privacy_breach',
  copyRightEntity: 'Partyhat Inc',
  hasCustomerServiceSupport: true,
  ssoRedirectURL: 'https://www.getpartyhat.com',
  carouselBanners: false,
  dwEmailVerification: {
    adaChat: false,
    signInButton: false,
    supportAt: 'support@getpartyhat.com',
    availability: null,
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {},
    email: {
      active: true,
      address: 'support@getpartyhat.com',
      customerSupport: true,
    },
  },
};

export default PARTYHAT_BRAND_CONFIG;
